//package
import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup, Card, Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import FacebookLogin from "react-facebook-login";

// component
import AmlHashForm from "aml-hash-form";
import { api, common, config } from "includes";

export default function Login() {
  // const
  const navigate = useNavigate();

  // state
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [utils, setUtils] = useState<any>({
    loginSubmit: false,
    emailErr: null,
    pwdErr: null,
  });
  // form
  const formFields = {
    email: {
      validate: [
        "req#Email is required",
        // "email#Please enter a valid email address",
        "regExp#Please Enter valid email address",
      ],
      pattern: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    },
    password: {
      validate: [
        "req#Password is required!",
        "min:8#Password should be minimum 8 Digits",
        "max:15#Password should be maximum 15 Digits",
      ],
    },
  };

  const { fields, errors, handleChange, handleSubmit } =
    AmlHashForm(formFields);

  // effect

  useEffect(() => {
    common.tempDataRemove();
  }, []);

  // event
  const onSubmit = (e: any) => {
    e.preventDefault();
    const isValid = handleSubmit();
    if (isValid) {
      Login();
    }
  };

  const responseFacebook = (response: any) => {
    console.log("User Data:", response);
  };

  // api
  const Login = () => {
    utilsState("loginSubmit", true);

    let data: any = {
      url: "app/auth/login",
      method: "POST",
      auth: "none",
      body: fields,
    };

    api.call(data, (res: any) => {
      if (res.status === 200) {
        let data = res?.data?.data;
        if (res.data.code == "success") {
          if (["super", "admin"].includes(data.role)) {
            common.localSet("authData", common.crypt(data, true));
            common.notify("S", `Welcome ${data?.firstName}!`);
            setTimeout(function () {
              // Incident reporting is the portal's primary job — land
              // straight on the form when the admin can create incidents.
              navigate(
                data?.permission?.includes("inc")
                  ? "/incident/form?mode=add"
                  : "/app/home"
              );
            }, 500);

            utilsState("emailErr", null);
            utilsState("pwdErr", null);
          } else {
            common.notify("E", "Only allowed admin users");
          }
        } else if (res?.data?.code === "email_not_verified") {
          // The API has already mailed a fresh code at this point. This case was
          // missing from the switch below, so it fell through to `default:
          // break` — the button spun, nothing appeared, and the admin had no
          // way to know a code was waiting in their inbox.
          const target = res?.data?.data?.email || fields.email;
          common.tempDataSet(target);
          common.notify("S", "Check your email for a verification code.");
          navigate("/verify/email", { state: { email: target } });
        } else {
          switch (res?.data?.code) {
            case "account_not_found":
            case "unauthorized":
            case "not_verified":
            case "inactive":
            case "admin_verify":
            case "account_inactive":
            case "wrong_account_type":
            case "deleted_account":
              utilsState("emailErr", res.data.message);
              utilsState("pwdErr", null);
              break;
            case "incorrect_password":
              utilsState("pwdErr", res.data.message);
              utilsState("emailErr", null);
              break;
            default:
              break;
          }
        }
      } else {
        common.notify("E", "Cannot Connect to Server, Please try Again!");
      }
      utilsState("loginSubmit", false);
    });
  };

  //support
  const handleKeyPress = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSubmit(e);
    }
  };

  const utilsState = (label: any, value: any) => {
    setUtils((prev: any) => ({
      ...prev,
      [label]: value,
    }));
  };

  //render
  return (
    <Row className="justify-content-center">
      <Col xxl={4} lg={5}>
        <Card>
          <Card.Header className="py-4 text-center bg-primary">
            <Link to="/">
              <span>
                <img src={common.loadImg("logo.png")} alt="logo" height="30" />
              </span>
            </Link>
          </Card.Header>
          <Card.Body className="p-4">
            <div className="text-center w-75 m-auto">
              <h4 className={`text-dark-50 text-center pb-0 fw-bold`}>
                Sign In
              </h4>
              <p className="text-muted mb-4">
                Enter your email address and password to access admin panel.
              </p>
            </div>
            <form
              onKeyDown={(e: React.KeyboardEvent<HTMLFormElement>) =>
                handleKeyPress(e)
              }
            >
              <Form.Group className={"mb-3"}>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  isInvalid={
                    errors.email || utils.emailErr != null ? true : false
                  }
                  name="email"
                  placeholder="Enter your email"
                  value={fields.email}
                  onChange={handleChange}
                />
                <Form.Control.Feedback type="invalid">
                  {utils.emailErr != null ? utils.emailErr : errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className={"mb-3"}>
                <Form.Label>Password</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    isInvalid={
                      errors.password || utils.pwdErr != null ? true : false
                    }
                    name="password"
                    placeholder="Enter your password"
                    value={fields.password}
                    onChange={handleChange}
                  />
                  <div
                    className={`input-group-text input-group-password ${showPassword ? "" : "show-password"
                      }`}
                    data-password={showPassword ? "true" : "false"}
                  >
                    <span
                      className="password-eye"
                      onClick={() => setShowPassword(!showPassword)}
                    ></span>
                  </div>
                  <Form.Control.Feedback type="invalid">
                    {utils.pwdErr != null ? utils.pwdErr : errors.password}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  {
                    <Form.Group className={"mb-3"}>
                      <Form.Check type="checkbox">
                        <Form.Check.Input type="checkbox" id="rememberMe" />
                        <Form.Check.Label htmlFor="rememberMe">
                          Remember me
                        </Form.Check.Label>
                      </Form.Check>
                      <Form.Control.Feedback type="invalid">
                        Error
                      </Form.Control.Feedback>
                    </Form.Group>
                  }
                </div>
                <div className={"mb-3"}>
                  <Link to="/password/forgot">Forgot password</Link>
                </div>
              </div>

              <div className="mb-3 text-center">
                <Button
                  variant="primary"
                  type="button"
                  onClick={onSubmit}
                  disabled={utils.loginSubmit ? true : false}
                >
                  {" "}
                  {utils.loginSubmit && (
                    <span
                      role="status"
                      className="spinner-border text-white  spinner-border-sm me-2"
                    ></span>
                  )}
                  {utils.loginSubmit ? "Loading.." : "Log In"}
                </Button>
              </div>
              {/* "Sign in with Google" removed 2026-08-13. Nobody used it, and
                  it authenticated against an OAuth client in a Google Cloud
                  project we do not own — a partner hit origin_mismatch on
                  staging, which we could not have fixed without access to that
                  project. Portal sign-in is email and password only.
                  The API's Google endpoints are untouched; only this button and
                  its client id are gone. */}
              {/* <div className="d-flex align-items-center justify-content-center">
                <FacebookLogin
                  appId="891535999464182"
                  autoLoad={false}
                  fields="name,email,picture"
                  scope="public_profile,email"
                  callback={responseFacebook}
                />
              </div> */}
            </form>
          </Card.Body>
        </Card>
        {/* The "Don't have an account? Sign Up" block that sat here (already
            commented out) is gone with the registration page — see App.tsx.
            Portal accounts are created by a super on the Users page. */}
      </Col>
    </Row>
  );
}
